/** @jsxImportSource @emotion/react **/
import React, { FC, useContext, useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Select from "react-select";

import { LANG_ALL, styleContainer } from '../../../pages/utils';
import { Context } from '../../../context/AboutUsContext'
import { BaseInput, Text, TextareaInput } from '../../atoms'
import { ContentSection } from '../../organisms'
import * as styles from "../Header/index.styles";

const AboutUsForm: FC = () => {
  const {
    formData,
    handleChangeFormData: handleChange,
    handleUpdateFormData: handleData,
  } = useContext(Context)

  const { id } = useParams();
  const detail_data = useSelector((state: any) => state.get_about_us.data)
  const news_data = id ? detail_data?.data.find((r: any) => r.id === id) : null

  const langInit = news_data?.lang
    ? { value: news_data.lang, label: news_data.lang }
    : { value: '', label: '' }

  const [isTitleValid, setTitleValid] = useState<boolean>(false)
  const [isDescriptionValid, setDescriptionValid] = useState<boolean>(false)

  useEffect(() => {
    if (!!id) {
      handleData(news_data)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, news_data])

  useEffect(() => {
    setTitleValid(formData.title.length > 2)
  }, [formData.title])

  useEffect(() => {
    setDescriptionValid(formData.description.length > 0)
  }, [formData.description])

  const handleLang = (e: any) => {
    handleChange({ lang: e.value })
  }

  return (
    <ContentSection
      style={styleContainer}
      header={
        <React.Fragment>
          <Text textType='h4' weight='black'>
            {id ? 'Editar' : 'Nuevo'} ¿Quiénes somos?
          </Text>
        </React.Fragment>
      }
    >
      <BaseInput
        label='Título'
        value={formData.title}
        onChange={(value) => handleChange({ title: value })}
        placeholder='Escribe un título'
        maxLength={500}
        error={!isTitleValid && formData.title.length > 0}
        success={isTitleValid}
        hint={!isTitleValid && formData.title.length > 0 ? 'Digite más de dos letras' : ''}
      />

      <TextareaInput
        label='Descripción'
        value={formData.description}
        onChange={(value) => handleChange({ description: value })}
        placeholder='Escribe una descripción'
        maxLength={500}
        error={!isDescriptionValid && formData.description.length > 0}
        success={isDescriptionValid}
        hint={!isDescriptionValid && formData.description.length > 0 ? 'Digite más de una letra' : ''}
      />

      <Text textType="label">
        IDIOMA:{' '}
        <Select
          css={styles.input}
          options={LANG_ALL}
          defaultValue={langInit}
          onChange={(e) => handleLang(e)}
        />
      </Text>
    </ContentSection>
  )
}

export default AboutUsForm